import * as React from "react"

export default function ChartLoading() {
    return <div className="loadingChart">
        <div className="chart"></div><div className="legends"></div>
    </div>
}